module.exports = __webpack_public_path__ + "static/img/6.5412f35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fu_shenfree/6.png
// module id = WfDd
// module chunks = 0